import { cva } from 'class-variance-authority'

export const menuStyles = cva(
  `
    flex
    flex-col
    p-1
    min-w-[8rem]
    overflow-y-auto
    overflow-x-hidden
    rounded-md
    border
    bg-neutral-0
    text-neutral-600
    shadow-md
    border-neutral-900
    data-[state=closed]:animate-out
    data-[state=open]:animate-in
    data-[state=closed]:fade-out-0
    data-[state=open]:fade-in-0
    data-[state=closed]:zoom-out-95
    data-[state=open]:zoom-in-95
    data-[side=bottom]:slide-in-from-top-2
    data-[side=left]:slide-in-from-right-2
    data-[side=right]:slide-in-from-left-2
    data-[side=top]:slide-in-from-bottom-2
  `
)

export const menuItemStyles = cva(
  `
    flex
    select-none
    items-center
    rounded-sm
    py-1.5
    pl-2
    pr-8
    text-sm
    hover:bg-neutral-25
    hover:cursor-pointer
    focus:bg-accent
    focus:text-accent-foreground
    data-[disabled]:pointer-events-none
    data-[disabled]:bg-neutral-50
  `,
  {
    variants: {
      active: {
        true: 'bg-neutral-25',
      },
    },
  }
)
